import { Home, Users, Swords, Bomb, UserCircle2, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

type MobileTabId = 'dashboard' | 'myteam' | 'matchups' | 'sabotage' | 'players';

interface MLBBetaBottomNavProps {
  activeTab: string;
  onTabChange: (tab: MobileTabId) => void;
}

const TABS: ReadonlyArray<{ id: MobileTabId; label: string; icon: LucideIcon }> = [
  { id: 'dashboard', label: 'Home',     icon: Home },
  { id: 'myteam',    label: 'Team',     icon: Users },
  { id: 'matchups',  label: 'H2H',      icon: Swords },
  { id: 'sabotage',  label: 'Sabotage', icon: Bomb },
  { id: 'players',   label: 'Players',  icon: UserCircle2 },
];

const MLBBetaBottomNav = ({ activeTab, onTabChange }: MLBBetaBottomNavProps) => {
  return (
    <nav className="sm:hidden fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/95 backdrop-blur-xl">
      <div className="grid grid-cols-5 items-center" style={{ height: '60px' }}>
        {TABS.map(({ id, label, icon: Icon }) => {
          const active = activeTab === id;
          return (
            <button
              key={id}
              onClick={() => onTabChange(id)}
              aria-label={label}
              aria-current={active ? 'page' : undefined}
              className={cn(
                'flex flex-col items-center justify-center gap-0.5 h-full font-medium transition-colors active:scale-95 touch-manipulation',
                active ? 'text-primary' : 'text-muted-foreground',
              )}
            >
              <Icon className="w-6 h-6" />
              <span className="text-[10px] leading-none whitespace-nowrap">{label}</span>
            </button>
          );
        })}
      </div>
      <div style={{ height: 'max(env(safe-area-inset-bottom, 20px), 16px)' }} />
    </nav>
  );
};

export default MLBBetaBottomNav;
